<template>
    <div class="search-goods">
        <div class="search-header">
            <div class="header-tip">
                <mu-icon value="chevron_left" size="30" @click="back"></mu-icon>
            </div>

            <div class="search-key">
                <mu-text-field v-model="searchText" placeholder="Find the name of the dish"  v-on:input="search"></mu-text-field>

            </div>
            <div class="search-btn">
                <mu-button flat class="search-btn-text" @click="search">Search</mu-button>
            </div>
        </div>
        <div class="foods-wrapper" ref="foodsWrapper">
            <ul v-for="food in goods" class="food-item">
                <img width="80" height="60" :src="getImgUrl(food.FoodImageNail)" @click="selectFood(food)">
                <div class="content">
                    <h2 class="name">{{food.FoodName}}</h2>
                    <div class="price" style="padding-top:10px;">
                        <span class="now">{{Number(food.Price * food.ActDiscount).toFixed(0)}} {{seller.Unit}}</span><span v-show="food.ActDiscount!=1" class="old">{{food.Price}} {{seller.Unit}}</span>
                    </div>
                    <div class="cart-wrapper">
                        <cartcontrol :food="food"></cartcontrol>
                    </div>
                </div>
            </ul>
        </div>
        <shopcart :select-foods="selectFoods" :delivery-price="42" :min-price="12"></shopcart>
        <food :food="selectedFood" ref="food"></food>
    </div>
</template>

<script>
    import shopcart from '../components/ShopCart'
    import cartcontrol from '../components/CartControl'
    import food from '../components/Food'

      export default {
        props: {
            seller: {
                type: Object
              }
        },
        data() {
            return {
                goods: [],
                selectedFood: {},
                searchText: "",
                isSeft:0
            }
        },
        computed: {
            selectFoods() {
                let foods = [];
                this.goods.forEach((food) => {
                    if (food.Quantity) {
                        foods.push(food);
                    }
                })
                return foods
            }
        },
        created() {           
        },
        mounted() {
            this.initData();
        },
        methods: {
            initData() {
                this.isSeft = this.$route.query.isSeft;
            },
            back() {
                if (this.isSeft == 0) {
                    this.$router.push({ path: '/restaurant' });
                }
                else {
                    this.$router.push({ path: '/buffet' });
                }
            },
            selectFood(food) {
                this.selectedFood = food;
                this.$refs.food.show();
            },
            getGoodList() {
                let param = {
                    searchKey: this.searchText,
                    clientId: 2,
                    isSeft: this.isSeft
                };
                this.$get('TakeAway/GetSearchFoodList', param)
                    .then(response => {
                        if (response != null) {
                            this.goods = [];
                            response.forEach((food) => {
                                if (food.ActDiscount==0) {
                                    food.ActDiscount = 1;
                                }
                                this.goods.push(food);
                            })
                        } else {
                            this.$alert('The web cannot be accessed, please contact the manager!', 'Alert');
                        }
                    });
            },
            search() {
                this.getGoodList();
            },
            getImgUrl(image) {
                if (image == undefined || image == 'undefined' || image == null) {
                    return '../static/img/default.png';
                }
                return this.ImageBaseUrl + image;
            },
            getPath() {
                if (this.$route.path == '/search' && this.isSeft != this.$route.query.isSeft) {
                    this.isSeft = this.$route.query.isSeft;
                    this.getGoodList();
                }
            }
        },
        watch: {
            '$route': 'getPath'
        },
        components: {
            shopcart,
            cartcontrol,
            food
        }
    }
</script>

<style lang="stylus" rel="stylesheet/stylus">
    .search-goods {
        position: fixed;
        top: 0px;
        bottom: 44px;
        width: 100%;
        max-width: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        overflow: hidden;
        background-color: #fafafa;
    }
        .search-goods .search-header {
            position: fixed;
            float: left;
            margin-top:10px;
        }
    .search-header .header-tip {
        float: left;
        width: 30px;
        position: relative;
        color: #424242;
        width: 12%;
    }

    .search-header .search-key {
        float: left;
        width: 62%;
    }

    .search-header .search-btn {
        float: left;
        width: 10%;
        height: 30px;
        line-height: 30px;
    }
    .search-header .search-btn-text {
        text-transform: unset;
    }

    .search-goods .menu-wrapper {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 80px;
        flex: 0 0 80px;
        background: #f3f5f7;
    }


    .search-goods .foods-wrapper {
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        margin-top: 40px;
        overflow-y: auto;
    }
        .search-goods .foods-wrapper h1 {
            margin: 0px;
        }
        .search-goods .foods-wrapper .title {
            padding-left: 14px;
            border-left: 2px solid #d9dde1;
            font-size: 12px;
            height: 26px;
            line-height: 26px;
            color: #93999f;
            background-color: #f3f5f7;
        }

        .search-goods .foods-wrapper .food-item {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            margin: 18px;
            padding-bottom: 18px;
            position: relative;
        }

            .search-goods .foods-wrapper .food-item:after {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                border-top: 1px solid rgba(7,17,27,0.1);
                content: '';
            }

            .search-goods .foods-wrapper .food-item:last-child:after {
                border-top: 0;
            }

            .search-goods .foods-wrapper .food-item .icon {
                -webkit-box-flex: 0;
                -ms-flex: 0 0 57px;
                flex: 0 0 57px;
                margin-right: 10px;
            }

            .search-goods .foods-wrapper .food-item .content {
                -webkit-box-flex: 1;
                -ms-flex: 1;
                flex: 1;
                margin-left: 5px;
            }

                .search-goods .foods-wrapper .food-item .content .name {
                    margin: 2px 0 8px 0;
                    height: 14px;
                    line-height: 14px;
                    font-size: 14px;
                    color: #07111b;
                }

                .search-goods .foods-wrapper .food-item .content .description,
                .search-goods .foods-wrapper .food-item .content .extra {
                    font-size: 10px;
                    line-height: 10px;
                    color: #93999f;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    word-break: break-all;
                    height: 10px;
                    line-height: 10px;
                }

                    .search-goods .foods-wrapper .food-item .content .extra .count {
                        margin-right: 12px;
                        line-height: 10px;
                    }

                    .search-goods .foods-wrapper .food-item .content .extra .rating {
                        line-height: 10px;
                    }

                .search-goods .foods-wrapper .food-item .content .price .now {
                    font-size: 14px;
                    color: #f01414;
                    font-weight: 700;
                    line-height: 24px;
                    margin-right: 8px;
                }

                .search-goods .foods-wrapper .food-item .content .price .old {
                    font-size: 12px;
                    text-decoration: line-through;
                    color: #93999f;
                    font-weight: 700;
                    line-height: 24px;
                }

                .search-goods .foods-wrapper .food-item .content .cart-wrapper {
                    position: absolute;
                    right: 0;
                    bottom: 12px;
                }
</style>



// WEBPACK FOOTER //
// src/components/Search.vue